import { useEffect } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import JobTracking from 'builder/components/JobTracking'

const JobTrackingView = (props: any) => {
  // Track the page opening
  useEffect(() => {
    trackInternalEvent('visit_job_tracking')
  }, [])

  return <JobTracking {...props} />
}

export default JobTrackingView
